import {
	type SetLastSelectedCardKey,
	SET_LAST_SELECTED_CARD_KEY,
} from '../../../../actions/cards/selection';
import type { LastSelectedCardKeyState } from './types';

const initialState = '';

export type Action = SetLastSelectedCardKey;

export const lastSelectedCardKeyReducer = (
	state: LastSelectedCardKeyState = initialState,
	action: Action,
) => {
	if (action.type === SET_LAST_SELECTED_CARD_KEY) {
		const { cardKey } = action.payload;
		return cardKey;
	}

	return state;
};
